'use strict';

var List = require("bs-platform/lib/js/list.js");
var $$Array = require("bs-platform/lib/js/array.js");
var Block = require("bs-platform/lib/js/block.js");
var $$String = require("bs-platform/lib/js/string.js");
var DateFns = require("bs-date-fns/src/DateFns.js");
var Js_option = require("bs-platform/lib/js/js_option.js");
var GatsbyLink = require("gatsby-link");
var GithubSlugger = require("./GithubSlugger.js");
var NikJpg = require("./assets/nik.jpg");
var AndreyJpg = require("./assets/andrey.jpg");
var SanderJpg = require("./assets/sander.jpg");
var PatrickJpg = require("./assets/patrick.jpg");
var ChengLouJpg = require("./assets/cheng-lou.jpg");
var SeanGroveJpg = require("./assets/sean-grove.jpg");
var Caml_builtin_exceptions = require("bs-platform/lib/js/caml_builtin_exceptions.js");
var GlennSlotteJpg = require("./assets/glenn-slotte.jpg");
var LanceHarperJpg = require("./assets/lance-harper.jpg");
var MaximValckeJpg = require("./assets/maxim-valcke.jpg");
var JaredForsythJpg = require("./assets/jared-forsyth.jpg");
var LauraGaetanoJpg = require("./assets/laura-gaetano.jpg");
var RomanSchieferJpg = require("./assets/roman-schiefer.jpg");
var JavierChavarriJpg = require("./assets/javier-chavarri.jpg");
var KeiraHodgkisonJpg = require("./assets/keira-hodgkison.jpg");
var G2iLogoSvg = require("./assets/partners/g2i-logo.svg");
var CristianoCalcagnoJpg = require("./assets/cristiano-calcagno.jpg");
var SpeakerPlaceholderSvg = require("./assets/speaker-placeholder.svg");
var VladimirKurchatkinJpg = require("./assets/vladimir-kurchatkin.jpg");
var AccentureLogoSvg = require("./assets/partners/accenture-logo.svg");
var JanestreetLogoSvg = require("./assets/partners/janestreet-logo.svg");

function find_opt(fn, l) {
  try {
    return /* Some */[List.find(fn, l)];
  }
  catch (exn){
    if (exn === Caml_builtin_exceptions.not_found) {
      return /* None */0;
    } else {
      throw exn;
    }
  }
}

var organizers_000 = /* record */[
  /* name */"Patrick Stapfer",
  /* imgUrl */PatrickJpg,
  /* href */"https://twitter.com/ryyppy",
  /* twitter */"ryyppy"
];

var organizers_001 = /* :: */[
  /* record */[
    /* name */"Nik Graf",
    /* imgUrl */NikJpg,
    /* href */"https://twitter.com/nikgraf",
    /* twitter */"nikgraf"
  ],
  /* :: */[
    /* record */[
      /* name */"Andrey Okonetchnikov",
      /* imgUrl */AndreyJpg,
      /* href */"https://twitter.com/okonetchnikov",
      /* twitter */"okonetchnikov"
    ],
    /* [] */0
  ]
];

var organizers = /* :: */[
  organizers_000,
  organizers_001
];

var Organizer = /* module */[/* organizers */organizers];

function talkSlug(param) {
  return GithubSlugger.slug(param[/* title */0]);
}

function speakerAnchor(param) {
  return Js_option.getWithDefault("tba", param[/* social */7][/* githubUser */1]);
}

function createPlaceholder($staropt$star, talk, $staropt$star$1, _) {
  var company = $staropt$star ? $staropt$star[0] : "?";
  var name = $staropt$star$1 ? $staropt$star$1[0] : "TBA";
  return /* record */[
          /* name */name,
          /* company */company,
          /* imgUrl */SpeakerPlaceholderSvg,
          /* description */"Details will be announced reasonably soon!",
          /* talk */talk,
          /* video : None */0,
          /* slides : None */0,
          /* social : record */[
            /* twitterUser : None */0,
            /* githubUser : None */0,
            /* website : None */0
          ]
        ];
}

var chengLou_003 = /* description */"I work on Reason and Facebook Messenger";

var chengLou_004 = /* talk : Some */[/* record */[
    /* title */"Keynote",
    /* abstract */""
  ]];

var chengLou_007 = /* social : record */[
  /* twitterUser : Some */["_chenglou"],
  /* githubUser : Some */["chenglou"],
  /* website : None */0
];

var chengLou = /* record */[
  /* name */"Cheng Lou",
  /* company */"Facebook",
  /* imgUrl */ChengLouJpg,
  chengLou_003,
  chengLou_004,
  /* video : None */0,
  /* slides : None */0,
  chengLou_007
];

var keiraHodgkison_003 = /* description */"\nKeira is a developer at Culture Amp, the world\'s\nleading culture analytics platform. She works with React, Flow,\nand Rails on solutions to help customers share, and act upon\ncompany employee engagement data. Keira is an advocate for using\nfunctional programming techniques to improve the JavaScript\ncoding and refactoring experience. When she\'s not writing code,\nshe can be found under a large cat.\n       ";

var keiraHodgkison_004 = /* talk : Some */[/* record */[
    /* title */"What’s not to love about Reason?",
    /* abstract */"\nEven though Reason looks like JavaScript with a few\nadditional functional features and semantics, it\'s sometimes\neasy to forget that it\'s a completely different language,\nwith different problems.\n\nThis talk looks at life on the bleeding edge, as experienced by a\nnot-so-functional programmer.\n       "
  ]];

var keiraHodgkison_006 = /* slides : Some */["https://www.slideshare.net/KeiraHodgkison/whats-not-to-love-about-reasonml"];

var keiraHodgkison_007 = /* social : record */[
  /* twitterUser : Some */["keirasaid"],
  /* githubUser : Some */["keirah"],
  /* website : None */0
];

var keiraHodgkison = /* record */[
  /* name */"Keira Hodgkison",
  /* company */"Culture Amp",
  /* imgUrl */KeiraHodgkisonJpg,
  keiraHodgkison_003,
  keiraHodgkison_004,
  /* video : None */0,
  keiraHodgkison_006,
  keiraHodgkison_007
];

var cristianoCalcagno_003 = /* description */"\nEngineer at Facebook.\nCo-creator of @fbinfer, founder of Monoidics, reformed academic.\nInto developer experience, front-end, static analysis, language design.\nEarly @reasonml adopter, co-creator of ReasonReact.\n       ";

var cristianoCalcagno_004 = /* talk : Some */[/* record */[
    /* title */"ReasonReact and local state",
    /* abstract */"\nThe talk introduces ReasonReact and the way it operates on the state\nof React components.  This is illustrated by introducing the notion of\nlocal state presented via a series of examples.\n\nState is changed by means of reducers, that can operate directly on\nthe current component, or on distant components via remote actions.\n\nFurther examples illustrate how certain animations can be considered\ninstances of local state that can be easily composed.\n"
  ]];

var cristianoCalcagno_007 = /* social : record */[
  /* twitterUser : Some */["ccrisccris"],
  /* githubUser : Some */["cristianoc"],
  /* website : None */0
];

var cristianoCalcagno = /* record */[
  /* name */"Cristiano Calcagno",
  /* company */"Facebook",
  /* imgUrl */CristianoCalcagnoJpg,
  cristianoCalcagno_003,
  cristianoCalcagno_004,
  /* video : None */0,
  /* slides : None */0,
  cristianoCalcagno_007
];

var lauraGaetano_003 = /* description */"\nLaura is a manager at Travis Foundation and the\norganiser of [Rails Girls Summer of Code](https://railsgirlssummerofcode.org/) --\na 3-month scholarship\nprogram to support women in the Open Source community. With a\nbackground in the visual arts and a non-traditional career path,\nshe landed in tech as a web developer somewhat by\naccident. Laura is passionate about making things, coaching at\nprogramming workshops, Open Source software, feminism, music and\nspace (as in rockets).\n       ";

var lauraGaetano_004 = /* talk : Some */[/* record */[
    /* title */"Building inclusive Open Source communities",
    /* abstract */"\nTech has a diversity problem: marginalised people are being pushed out\nof the industry; their voices and experiences are erased. Open Source\nis particularly bad, with too few contributors who aren’t white, male,\ncisgender and able-bodied.\n\nWhat if things were different? What if we could create spaces that are\nwelcoming, where we show empathy and compassion? What if those\nqualities could reflect in our work, ultimately helping us create\nbetter software?\n\nIn this talk, you will hear stories of first-time contributions,\nsuccessful examples in supporting and mentoring newcomers, and find\nout steps you can take as an Open Source contributor or maintainer to\nmake your community more inclusive.\n"
  ]];

var lauraGaetano_006 = /* slides : Some */["https://speakerdeck.com/alicetragedy/building-inclusive-open-source-communities-1"];

var lauraGaetano_007 = /* social : record */[
  /* twitterUser : Some */["alicetragedy"],
  /* githubUser : Some */["alicetragedy"],
  /* website : Some */["http://www.alicetragedy.org/"]
];

var lauraGaetano = /* record */[
  /* name */"Laura Gaetano",
  /* company */"Travis Foundation",
  /* imgUrl */LauraGaetanoJpg,
  lauraGaetano_003,
  lauraGaetano_004,
  /* video : None */0,
  lauraGaetano_006,
  lauraGaetano_007
];

var sanderSpies_003 = /* description */"As a developer always focusing on the reader of\n      the code. Fell in love with React in 2013 because of the\n      simplification it brought to state management. Regrets asking\n      for Flux. Big fan of CSS-in-JS and currently lost in\n      OCaml. Strongly believes in the importance of moving developers\n      to Reason as it removes a lot of the burdens that JavaScript\n      developers face daily. Can be blamed for several things in\n      Reason like JSX. Reason fan since day one.";

var sanderSpies_004 = /* talk : Some */[/* record */[
    /* title */"Down the WebAssembly rabbit hole",
    /* abstract */"\nIn this talk we go beyond syntax and look at an experimental\nwebassembly backend for OCaml / ReasonML.\n"
  ]];

var sanderSpies_006 = /* slides : Some */["https://drive.google.com/open?id=1HTfQDPvDpcw_3nFUh3y5PA-T3wuRIF11"];

var sanderSpies_007 = /* social : record */[
  /* twitterUser : Some */["Sander_Spies"],
  /* githubUser : Some */["SanderSpies"],
  /* website : None */0
];

var sanderSpies = /* record */[
  /* name */"Sander Spies",
  /* company */"Independent",
  /* imgUrl */SanderJpg,
  sanderSpies_003,
  sanderSpies_004,
  /* video : None */0,
  sanderSpies_006,
  sanderSpies_007
];

var vladimirKurchatkin_001 = /* company */"Backend Developer at Lazada";

var vladimirKurchatkin_004 = /* talk : Some */[/* record */[
    /* title */"Building native Node.js addons in Reason",
    /* abstract */"\nReason community is growing rapidly, and a lot of people are\ninterested in leveraging it on their servers. One way to achieve this\nis to use native OCaml compiler. It produces exceptionally performant\nbinaries, but the native ecosystem is scarce, and you will struggle\nwith finding solutions for very common tasks.\n\nAnother option is to use BuckleScript and compile everything to\nJavaScript. You would regain access to the vast Node.js ecosystem but\nwould have to sacrifice performance. It seems that you have to choose\neither ecosystem or performance.\n\nIn this talk, I will show how to preserve both by compiling Reason\ncode to native Node.js addons. I will present a toolkit that makes it\neasy and fun, walk through its features and examples and talk a bit\nabout its internals and advanced OCaml features used.\n"
  ]];

var vladimirKurchatkin_007 = /* social : record */[
  /* twitterUser : Some */["vkurchatkin"],
  /* githubUser : Some */["vkurchatkin"],
  /* website : None */0
];

var vladimirKurchatkin = /* record */[
  /* name */"Vladimir Kurchatkin",
  vladimirKurchatkin_001,
  /* imgUrl */VladimirKurchatkinJpg,
  /* description */"OCaml enthusiast, Node.js and Flow contributor",
  vladimirKurchatkin_004,
  /* video : None */0,
  /* slides : None */0,
  vladimirKurchatkin_007
];

var javierChavarri_000 = /* name */"Javier Chávarri";

var javierChavarri_001 = /* company */"Tech Lead at Webflow";

var javierChavarri_003 = /* description */"\nJavi is Tech Lead at Webflow. He also helps improving the Reason IDE tooling, in particular the OCaml language server and the VSCode extension.\nCame to Reason led by the interest in finding better ways to create and maintain software. Stayed for the community (and OCaml!).\nExcited about what will happen when Reason and BuckleScript keep removing boundaries between native and web.\n       ";

var javierChavarri_004 = /* talk : Some */[/* record */[
    /* title */"State of the Reason Editor integration",
    /* abstract */"\nWe will review the current state of the IDE tooling for Reason:\n- Editors (and OSs) supported\n- How the different parts work (language clients and the main language server) and their repositories\n- Quick review of the differences between ocamlmerlin and bsb when it comes to IDE integration.\n- Finally, we will briefly look into the features that could be built next, steered by the community needs\n"
  ]];

var javierChavarri_006 = /* slides : Some */["https://drive.google.com/open?id=117HKqWoI2vE8njaJTQ_hbJM2qE36q95F"];

var javierChavarri_007 = /* social : record */[
  /* twitterUser : Some */["javierwchavarri"],
  /* githubUser : Some */["jchavarri"],
  /* website : None */0
];

var javierChavarri = /* record */[
  javierChavarri_000,
  javierChavarri_001,
  /* imgUrl */JavierChavarriJpg,
  javierChavarri_003,
  javierChavarri_004,
  /* video : None */0,
  javierChavarri_006,
  javierChavarri_007
];

var glennSlotte_003 = /* description */"\nGlenn is probably one of the most mysterious figures\nin the Reason community. He contributed essential bindings for the\nReason and BuckleScript ecosystem (bs-jest, bs-fetch, bs-json,...) and he\nis also the creator of redex.github.io.\n";

var glennSlotte_004 = /* talk : Some */[/* record */[
    /* title */"TBA",
    /* abstract */"TBA"
  ]];

var glennSlotte_007 = /* social : record */[
  /* twitterUser : None */0,
  /* githubUser : Some */["glennsl"],
  /* website : None */0
];

var glennSlotte = /* record */[
  /* name */"Glenn Slotte",
  /* company */"Freelance Code Monkey",
  /* imgUrl */GlennSlotteJpg,
  glennSlotte_003,
  glennSlotte_004,
  /* video : None */0,
  /* slides : None */0,
  glennSlotte_007
];

var lanceHarper_003 = /* description */" Growth focused engineer who loves building mobile experiences ";

var lanceHarper_004 = /* talk : Some */[/* record */[
    /* title */"Reason coming from F#",
    /* abstract */"\nF# has been a powerful language based on OCaml without mainstream\nadoption. Let\'s discuss their differences.\n         "
  ]];

var lanceHarper_007 = /* social : record */[
  /* twitterUser : None */0,
  /* githubUser : Some */["lanceharper"],
  /* website : None */0
];

var lanceHarper = /* record */[
  /* name */"Lance Harper",
  /* company */"Independent",
  /* imgUrl */LanceHarperJpg,
  lanceHarper_003,
  lanceHarper_004,
  /* video : None */0,
  /* slides : None */0,
  lanceHarper_007
];

var maximValcke_001 = /* company */"Software engineer at PieSync";

var maximValcke_003 = /* description */"\nSyncing contacts at PieSync by day, submitting PR\'s to Reason at\nnight. When not coding he likes to practise Spanish and get very tired\ndoing this thing called triathlon, sometimes simultaneously.\n       ";

var maximValcke_004 = /* talk : Some */[/* record */[
    /* title */"Practical Interpretation of Code Formatting",
    /* abstract */"\nToday every major language has some kind of library that helps a\ndeveloper formatting his or her code. Tools like Prettier, Gofmt and\nRefmt are setting new standards and have a deep impact on our day to\nday programming.\n\nBut what does it actually mean to format code?  Does it mean pressing\na magical button to align your code? Is it more than the automatic\ninsertion of trailing commas your colleague always seems to forget?\nWhy are we even doing it? How is it going to impact us as programmers\nto get better?\n\n\"Code formatting\" is an opaque ocean, we’ve done a really poor job\nat explaining what code formatting actually means in today’s\nworld. The recent hype around code formatting tools defaults us into\nthinking that we can’t live without them anymore. We need to stop and\nask why we’re using these tools. Is it really the best course of\naction?\n\nBased on my experience contributing to Reason over the past 1.5 years,\nthis lightning talk will be a short, critical deep dive in the past,\npresent & future of our beloved Reason formatter Refmt.\n"
  ]];

var maximValcke_006 = /* slides : Some */["https://drive.google.com/open?id=1o13RpP1nbqKfYGkc2ko4PiyBW89Tx3YV"];

var maximValcke_007 = /* social : record */[
  /* twitterUser : Some */["_iwan_refmt"],
  /* githubUser : Some */["iwankaramazow"],
  /* website : None */0
];

var maximValcke = /* record */[
  /* name */"Maxim Valcke",
  maximValcke_001,
  /* imgUrl */MaximValckeJpg,
  maximValcke_003,
  maximValcke_004,
  /* video : None */0,
  maximValcke_006,
  maximValcke_007
];

var seanGrove_003 = /* description */"\nSean\'s been hacking on devtools, debuggers, unikernels, scrapers,\ngraphical tools, and apartment designers in ClojureScript, ReasonML,\nand Rust for years, alongside giving talks on various kinds of tech,\nall while shipping business products that handle millions in\nrevenue. It\'s mostly been luck though, he continues to spend late nights staring at the computer perplexed about how anything he writes works.\n";

var seanGrove_004 = /* talk : Some */[/* record */[
    /* title */"Having your cake and eating it too — GraphQL in Reason",
    /* abstract */"\nTraditionally, soundly typed-language are warm and cozy in their own\nworld, but as soon as they have to deal with the outside world (say,\ntalking to a REST API), the pain quickly sets in: trying to keep a\ntype definition in sync with a moving external service, manual\nconversion back and forth, and lots of boilerplate.\n\nWell no more! Proper GraphQL support in ReasonML libraries means that\nwe can have full-stack safety, knowing that if our programs compile,\nthe server can satisfy our requirements! And on top of that, we get\nall the other GraphQL goodies, like tooling, in-editor auto-complete,\nand fantastic compile-time optimizations, for free!\n\nBut what about the server-side, you ask? There are so many places\nthings can go wrong when trying to maintain the promises you give to\nyour GraphQL clients, I hear you cry out.\n\nDry your eyes, friend, for ocaml-graphql-server is here to guide you\nto the happy full-stack GraphQL+Reason world you\'ve been dreaming of,\nwhere whole classes of errors are eliminated.\n\nAs in any good talk however, we\'ll also take a look at some of the\npainful points of this approach, and how ReasonML might make some\ntasks more difficult, so that you can leave with a confident\nunderstanding of whether this new frontier is one you want to\nbrave any time soon.\n"
  ]];

var seanGrove_007 = /* social : record */[
  /* twitterUser : Some */["sgrove"],
  /* githubUser : Some */["sgrove"],
  /* website : Some */["http://www.riseos.com/"]
];

var seanGrove = /* record */[
  /* name */"Sean Grove",
  /* company */"Co-founder of onegraph.com",
  /* imgUrl */SeanGroveJpg,
  seanGrove_003,
  seanGrove_004,
  /* video : None */0,
  /* slides : None */0,
  seanGrove_007
];

var jaredForsyth_003 = /* description */"\nJared is one of the hosts of the ReasonTown podcast, and\ncontributes to Reason core. He works at Khan Academy doing\nmobile and web development, using React and React Native\nalongside native Java and Swift. He loves type systems and\nlearning new languages, and is deeply invested in improving the\nexperience of programming for everyone.\n";

var jaredForsyth_004 = /* talk : Some */[/* record */[
    /* title */"Why We’re Afraid of Change",
    /* abstract */"\nWould you rather have a community like npm, where there are hundreds\nof thousands of packages, but very few feel stable, or one like opam,\nwith only a few thousand packages and a much more rigorous vetting\nsystem? How do language and community decisions affect the pull\nbetween security and freedom, safety and agility? Can we design a\nsystem that gives us both?\n\nCome learn about how tools, language features, and community\nstructures all impact the \"feel\" of a developer community, and what\ntricks Reason could borrow from other communities to ensure that we\ncan have freedom to publish without fearing change.\n"
  ]];

var jaredForsyth_007 = /* social : record */[
  /* twitterUser : Some */["jaredforsyth"],
  /* githubUser : Some */["jaredly"],
  /* website : Some */["https://jaredforsyth.com"]
];

var jaredForsyth = /* record */[
  /* name */"Jared Forsyth",
  /* company */"Khan Academy",
  /* imgUrl */JaredForsythJpg,
  jaredForsyth_003,
  jaredForsyth_004,
  /* video : None */0,
  /* slides : None */0,
  jaredForsyth_007
];

var romanSchiefer_003 = /* description */"\nRoman, based in Vienna, is Technology Architect inside Accenture’s\nEmerging Technologies domain. Together with his domain he brings new\ntechnologies to large scale enterprises all around the world. Roman’s\nfocus lies on Web- and Cloud-Native-Technologies as well as other\nSoftware-Innovation topics. He is currently managing a Reason\nimplementation for a large client.\n       ";

var romanSchiefer_004 = /* talk : Some */[/* record */[
    /* title */"Using Reason in traditional Enterprises",
    /* abstract */"\nBringing new technologies to large-scale enterprises is a challenge in\nwhich we are involved quite often. In this talk we will reflect on our\ncurrent experience with Reason based on a real implementation.\n       "
  ]];

var romanSchiefer_006 = /* slides : Some */["https://drive.google.com/open?id=1Je6mTfQB4tKDzdMFEhRUUn7--Hb4nScK"];

var romanSchiefer_007 = /* social : record */[
  /* twitterUser : Some */["RSchiefer"],
  /* githubUser : Some */["RSchiefer"],
  /* website : None */0
];

var romanSchiefer = /* record */[
  /* name */"Roman Schiefer",
  /* company */"Accenture",
  /* imgUrl */RomanSchieferJpg,
  romanSchiefer_003,
  romanSchiefer_004,
  /* video : None */0,
  romanSchiefer_006,
  romanSchiefer_007
];

var tbaSpeaker = createPlaceholder(/* Some */["Accenture"], /* Some */[/* record */[
        /* title */"A small enterprise case-study",
        /* abstract */"TBA"
      ]], /* None */0, /* () */0);

var headlineSpeakers = /* array */[
  chengLou,
  keiraHodgkison,
  cristianoCalcagno,
  lauraGaetano
];

var otherSpeakers = /* array */[
  sanderSpies,
  vladimirKurchatkin,
  javierChavarri,
  romanSchiefer,
  lanceHarper,
  maximValcke,
  seanGrove,
  jaredForsyth
];

var speakers = $$Array.concat(/* :: */[
      headlineSpeakers,
      /* :: */[
        otherSpeakers,
        /* [] */0
      ]
    ]);

var Speaker = /* module */[
  /* talkSlug */talkSlug,
  /* speakerAnchor */speakerAnchor,
  /* createPlaceholder */createPlaceholder,
  /* chengLou */chengLou,
  /* keiraHodgkison */keiraHodgkison,
  /* cristianoCalcagno */cristianoCalcagno,
  /* lauraGaetano */lauraGaetano,
  /* sanderSpies */sanderSpies,
  /* vladimirKurchatkin */vladimirKurchatkin,
  /* javierChavarri */javierChavarri,
  /* glennSlotte */glennSlotte,
  /* lanceHarper */lanceHarper,
  /* maximValcke */maximValcke,
  /* seanGrove */seanGrove,
  /* jaredForsyth */jaredForsyth,
  /* romanSchiefer */romanSchiefer,
  /* tbaSpeaker */tbaSpeaker,
  /* headlineSpeakers */headlineSpeakers,
  /* otherSpeakers */otherSpeakers,
  /* speakers */speakers
];

function addDuration(time, duration) {
  if (duration) {
    return DateFns.addMinutes(duration[0], time);
  } else {
    return time;
  }
}

var day2Start = new Date("2018-05-11T11:00:00.000+02:00");

var duration = /* Some */[60];

var toTime = /* Some */[addDuration(day2Start, duration)];

var day1StartEntry_000 = /* task : Misc */Block.__(1, ["Doors open, Registration & Editor Setup"]);

var day1StartEntry = /* record */[
  day1StartEntry_000,
  /* fromTime */day2Start,
  /* toTime */toTime,
  /* duration */duration
];

var day2Start$1 = new Date("2018-05-12T11:00:00.000+02:00");

var duration$1 = /* Some */[60];

var toTime$1 = /* Some */[addDuration(day2Start$1, duration$1)];

var day2StartEntry_000 = /* task : Misc */Block.__(1, ["Doors open & Registration"]);

var day2StartEntry = /* record */[
  day2StartEntry_000,
  /* fromTime */day2Start$1,
  /* toTime */toTime$1,
  /* duration */duration$1
];

var day1Steps_000 = /* record */[
  /* task : Workshop */Block.__(3, [/* :: */[
        seanGrove,
        /* :: */[
          jaredForsyth,
          /* [] */0
        ]
      ]]),
  /* duration : Some */[180]
];

var day1Steps_001 = /* :: */[
  /* record */[
    /* task : Break */Block.__(2, ["Lunch"]),
    /* duration : Some */[60]
  ],
  /* :: */[
    /* record */[
      /* task : Workshop */Block.__(3, [/* :: */[
            seanGrove,
            /* :: */[
              jaredForsyth,
              /* [] */0
            ]
          ]]),
      /* duration : Some */[240]
    ],
    /* :: */[
      /* record */[
        /* task : OpenEnd */Block.__(4, ["Open End until ImpactHub closes"]),
        /* duration : Some */[120]
      ],
      /* [] */0
    ]
  ]
];

var day1Steps = /* :: */[
  day1Steps_000,
  day1Steps_001
];

var day2Steps_000 = /* record */[
  /* task : Talk */Block.__(0, [chengLou]),
  /* duration : Some */[45]
];

var day2Steps_001 = /* :: */[
  /* record */[
    /* task : Break */Block.__(2, ["Coffee break"]),
    /* duration : Some */[30]
  ],
  /* :: */[
    /* record */[
      /* task : Talk */Block.__(0, [cristianoCalcagno]),
      /* duration : Some */[45]
    ],
    /* :: */[
      /* record */[
        /* task : Talk */Block.__(0, [lauraGaetano]),
        /* duration : Some */[45]
      ],
      /* :: */[
        /* record */[
          /* task : Break */Block.__(2, ["Lunch"]),
          /* duration : Some */[90]
        ],
        /* :: */[
          /* record */[
            /* task : Talk */Block.__(0, [sanderSpies]),
            /* duration : Some */[45]
          ],
          /* :: */[
            /* record */[
              /* task : Talk */Block.__(0, [javierChavarri]),
              /* duration : Some */[15]
            ],
            /* :: */[
              /* record */[
                /* task : Talk */Block.__(0, [romanSchiefer]),
                /* duration : Some */[15]
              ],
              /* :: */[
                /* record */[
                  /* task : Talk */Block.__(0, [lanceHarper]),
                  /* duration : Some */[15]
                ],
                /* :: */[
                  /* record */[
                    /* task : Talk */Block.__(0, [maximValcke]),
                    /* duration : Some */[15]
                  ],
                  /* :: */[
                    /* record */[
                      /* task : Break */Block.__(2, ["Coffee  break"]),
                      /* duration : Some */[30]
                    ],
                    /* :: */[
                      /* record */[
                        /* task : Talk */Block.__(0, [seanGrove]),
                        /* duration : Some */[45]
                      ],
                      /* :: */[
                        /* record */[
                          /* task : Talk */Block.__(0, [vladimirKurchatkin]),
                          /* duration : Some */[45]
                        ],
                        /* :: */[
                          /* record */[
                            /* task : Break */Block.__(2, ["Coffee  break"]),
                            /* duration : Some */[30]
                          ],
                          /* :: */[
                            /* record */[
                              /* task : Talk */Block.__(0, [keiraHodgkison]),
                              /* duration : Some */[45]
                            ],
                            /* :: */[
                              /* record */[
                                /* task : Talk */Block.__(0, [jaredForsyth]),
                                /* duration : Some */[45]
                              ],
                              /* :: */[
                                /* record */[
                                  /* task : OpenEnd */Block.__(4, ["After Party at Cafe Leopold"]),
                                  /* duration : None */0
                                ],
                                /* [] */0
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]
  ]
];

var day2Steps = /* :: */[
  day2Steps_000,
  day2Steps_001
];

function calcStep(pre, step) {
  var fromTime = addDuration(pre[/* fromTime */1], pre[/* duration */3]);
  var match = step[/* duration */1];
  var toTime = match ? /* Some */[addDuration(fromTime, step[/* duration */1])] : /* None */0;
  return /* record */[
          /* task */step[/* task */0],
          /* fromTime */fromTime,
          /* toTime */toTime,
          /* duration */step[/* duration */1]
        ];
}

function calcTimetable(pre, steps) {
  if (steps) {
    var next = calcStep(pre, steps[0]);
    return /* :: */[
            next,
            calcTimetable(next, steps[1])
          ];
  } else {
    return /* [] */0;
  }
}

function logTimetable(table) {
  return List.iter((function (r) {
                var match = r[/* task */0];
                var task;
                switch (match.tag | 0) {
                  case 0 : 
                      task = match[0][/* name */0];
                      break;
                  case 3 : 
                      task = $$String.concat(" ", List.map((function (speaker) {
                                  return speaker[/* name */0];
                                }), match[0]));
                      break;
                  default:
                    task = match[0];
                }
                var fromTime = DateFns.format("DD.MM, HH:mm", r[/* fromTime */1]);
                var match$1 = r[/* duration */3];
                var duration = match$1 ? " (" + (String(match$1[0]) + " min)") : "";
                var match$2 = r[/* toTime */2];
                var timeRange;
                if (match$2) {
                  var toTime = DateFns.format("HH:mm", match$2[0]);
                  timeRange = "" + (String(fromTime) + (" - " + (String(toTime) + ("" + (String(duration) + "")))));
                } else {
                  timeRange = fromTime;
                }
                console.log(task, " ", timeRange);
                return /* () */0;
              }), table);
}

var day1Timetable_001 = calcTimetable(day2StartEntry, day1Steps);

var day1Timetable = /* :: */[
  day1StartEntry,
  day1Timetable_001
];

var day2Timetable_001 = calcTimetable(day2StartEntry, day2Steps);

var day2Timetable = /* :: */[
  day2StartEntry,
  day2Timetable_001
];

var Timetable = /* module */[
  /* addDuration */addDuration,
  /* day1StartEntry */day1StartEntry,
  /* day2StartEntry */day2StartEntry,
  /* day1Steps */day1Steps,
  /* day2Steps */day2Steps,
  /* calcStep */calcStep,
  /* calcTimetable */calcTimetable,
  /* logTimetable */logTimetable,
  /* day1Timetable */day1Timetable,
  /* day2Timetable */day2Timetable
];

var sponsorTiers = /* array */[
  /* record */[
    /* id */"main",
    /* name */"Gold Sponsor",
    /* cost */5000,
    /* amount */1,
    /* description */"\n- Banner placement of your choice (stage, entrance and / or catering)\n- Logo on our website in the sponsor headline\n- Logo shown in every talk recording & voiceover with a message of your choice\n- Tweet mention\n- Job offer placement on our job-board\n- 3 tickets included (1050€)\n- Special cooperation to realize your own ideas at the conference\n  (booth, raffles, games, code-challenges, etc.)\n  "
  ],
  /* record */[
    /* id */"regular",
    /* name */"Coffee & Food",
    /* cost */2500,
    /* amount */3,
    /* description */"\n- Banner placement at our catering\n- Logo on our website\n- Logo shown in every talk recording\n- Tweet mention\n- Job offer placement on our job-board\n- 2 tickets included (700€)\n    "
  ],
  /* record */[
    /* id */"supporter",
    /* name */"Local Supporter",
    /* cost */1000,
    /* amount */10,
    /* description */"\n- Logo on the Website\n- 1 sponsoring package for the ReasonVienna meetup\n- Job offer placement on our job-board\n- 1 ticket included (350€)\n    "
  ]
];

var Tier = /* module */[/* sponsorTiers */sponsorTiers];

var data = /* array */[
  /* record */[
    /* tier : Gold */0,
    /* company : record */[
      /* logo : Some */[/* record */[
          /* src */AccentureLogoSvg,
          /* width */"300px"
        ]],
      /* href */"https://www.accenture.com/",
      /* descMd */"\nAccenture is a leading global professional services company, providing\na broad range of services and solutions in strategy, consulting,\ndigital, technology and operations.\n\nCombining unmatched experience and specialized skills across more than\n40 industries and all business functions – underpinned by the world’s\nlargest delivery network – Accenture works at the intersection of\nbusiness and technology to help clients improve their performance and\ncreate sustainable value for their stakeholders.\n\nWith approximately 442,000 people serving clients in more than 120\ncountries, Accenture drives innovation to improve the way the world\nworks and lives.\n\nVisit us at <a href=\"https://www.accenture.com\" target=\"_blank\">www.accenture.com</a>\n         "
    ],
    /* jobAds : array */[/* record */[
        /* location : OnSite */Block.__(0, ["Vienna, Austria"]),
        /* desc */"Consultant / Emerging Technology Innovation",
        /* href */"https://www.accenture.com/at-de/careers/jobdetails?id=00574672_de&title=Beraterin+%2f+Berater+im+Bereich+Emerging+Technology+Innovation&keyword=HJ_TEC|J_TEC|HJ_JAV|J_JAV|Technologieberaterin|Technologieberater|J_TECARCH"
      ]]
  ],
  /* record */[
    /* tier : Catering */1,
    /* company : record */[
      /* logo : Some */[/* record */[
          /* src */JanestreetLogoSvg,
          /* width */"300px"
        ]],
      /* href */"https://www.janestreet.com/",
      /* descMd */"\nJane Street is a quantitative trading firm and the largest industrial\nuser of OCaml, a functional programming language with a sophisticated\ntype system.\n\nThe company has more more than 250 developers writing\nOCaml to build reliable, high-performance software at massive scale,\nincluding critical systems that trade $13 billion in global equities\nevery day.\n\nJane Street developers help define the next generation of\nthe OCaml compiler and actively maintain nearly 100 open source\nprojects. The company has offices in New York, London, Hong Kong, and\nAmsterdam.\n         "
    ],
    /* jobAds : array */[
      /* record */[
        /* location : OnSite */Block.__(0, ["NYC, London, Hong Kong"]),
        /* desc */"Software Developer - Functional Programming",
        /* href */GatsbyLink.withPrefix("jobs/janestreet_software_developer.pdf")
      ],
      /* record */[
        /* location : Nothing */0,
        /* desc */"Other open positions",
        /* href */"https://www.janestreet.com/open-positions/"
      ]
    ]
  ],
  /* record */[
    /* tier : LocalSupport */2,
    /* company : record */[
      /* logo : Some */[/* record */[
          /* src */G2iLogoSvg,
          /* width */"80px"
        ]],
      /* href */"http://g2i.co/",
      /* descMd */"\nG2i offers USA, European, and South American based web and mobile\ndevelopers that can become part of your team at reasonable rates.\n\nOur devs are experienced with React, React Native, GraphQL, Node.js,\nand Android/iOS."
    ],
    /* jobAds : array */[
      /* record */[
        /* location : OnSite */Block.__(0, ["San Francisco"]),
        /* desc */"Senior React Engineer",
        /* href */"https://jobs.lever.co/g2i/d62d9cf2-67d4-42d4-a034-584acd5d277f"
      ],
      /* record */[
        /* location : RemoteOnly */1,
        /* desc */"React/Redux + Node/Rails Full Stack Developer",
        /* href */"https://jobs.lever.co/g2i/f6588986-eda0-4192-aa5c-9949ff509fa0"
      ],
      /* record */[
        /* location : RemoteOnly */1,
        /* desc */"React Native Engineer",
        /* href */"https://jobs.lever.co/g2i/58bf69ab-f263-4750-9023-9b88bee37159"
      ],
      /* record */[
        /* location : RemoteOnly */1,
        /* desc */"Remote Node Engineer",
        /* href */"https://jobs.lever.co/g2i/90988547-6a17-438c-acee-99d27fc94dd9"
      ]
    ]
  ]
];

var Job = /* module */[/* data */data];

exports.find_opt = find_opt;
exports.Organizer = Organizer;
exports.Speaker = Speaker;
exports.Timetable = Timetable;
exports.Tier = Tier;
exports.Job = Job;
/* organizers Not a pure module */



// WEBPACK FOOTER //
// ./src/data.js